export default __webpack_public_path__ + "static/media/rosca.7d42e65c.png";